import { Component, OnDestroy, ViewChild } from '@angular/core';
import { OrderEditingService } from '@app/pages/order-editing/order-editing.service';
import { AddressValidationFlaggedOrdersComponent } from './components/address-validation-flagged-orders/address-validation-flagged-orders.component';

@Component({
  selector: 'order-editing-form-address-validation',
  standalone: false,
  templateUrl: './order-editing-form-address-validation.component.html',
  styleUrl: './order-editing-form-address-validation.component.scss',
})
export class OrderEditingFormAddressValidationComponent implements OnDestroy {
  @ViewChild('flaggedOrders') flaggedOrders: AddressValidationFlaggedOrdersComponent;

  activeTab = 'configurations';

  constructor(public orderEditingService: OrderEditingService) {}

  ngOnDestroy(): void {
    this.orderEditingService.hidePreview.set(false);
  }

  onTabChange(tab: string): void {
    this.activeTab = tab;
    this.orderEditingService.hidePreview.set(tab === 'flagged-orders');
  }
}
